import properties from './modules/properties'
import realEstateDevelopments from './modules/real-estate-developments'
import realEstateDevelopmentsAccessories from './modules/real-estate-developments-accessories'
import realEstateDevelopmentsBatch from './modules/real-estate-developments-batch'
import realEstateDevelopmentsBlueprints from './modules/real-estate-developments-blueprints'
import realEstateDevelopmentsCharacteristics from './modules/real-estate-developments-characteristics'
import realEstateDevelopmentsDocuments from './modules/real-estate-developments-documents'
import realEstateDevelopmentsLayout from './modules/real-estate-developments-layout'
import realEstateDevelopmentsMedias from './modules/real-estate-developments-medias'
import realEstateDevelopmentsMirrors from './modules/real-estate-developments-mirrors'
import realEstateDevelopmentsParameters from './modules/real-estate-developments-parameters'
import realEstateDevelopmentsPersonalizations from './modules/real-estate-developments-settings-personalizations'
import realEstateDevelopmentsStages from './modules/real-estate-developments-stages'
import realEstateDevelopmentsTypologies from './modules/real-estate-developments-typologies'
import realEstateDevelopmentsUnits from './modules/real-estate-developments-units'
import registryOffices from './modules/registry-offices'

// real-estate-developments-settings
import realEstateDevelopmentsSettings from './modules/real-estate-developments-settings'
import realEstateDevelopmentsSettingsAccessories from './modules/real-estate-developments-settings-accessories'
import realEstateDevelopmentsSettingsAccessoriesCategorization from
  './modules/real-estate-developments-settings-accessories-categorization'
import realEstateDevelopmentsSettingsAttributes from './modules/real-estate-developments-settings-attributes'
import realEstateDevelopmentsSettingsBuyingOptions from './modules/real-estate-developments-settings-buying-options'
import realEstateDevelopmentsSettingsCharacteristics from './modules/real-estate-developments-settings-characteristics'
import realEstateDevelopmentsSettingsInsuranceCompanies from
  './modules/real-estate-developments-settings-insurance-companies'
import realEstateDevelopmentsSettingsInsurances from './modules/real-estate-developments-settings-insurances'
import realEstateDevelopmentsSettingsProposalModel from './modules/real-estate-developments-settings-proposal-model'
import realEstateDevelopmentsSettingsReferencePoints from './modules/real-estate-developments-settings-reference-points'
import realEstateDevelopmentsSettingsBankAgencies from './modules/real-estate-developments-settings-bank-agencies'
import realEstateDevelopmentsSettingsCreditPolicies from './modules/real-estate-developments-settings-credit-policies'

// TODO: depois de discutir com o front, rever sobre padronização das nomenclaturas
import installmentIntegrationTables from './modules/installment-integration-tables'

// reports
import reports from './modules/reports'

const routes = [
  {
    path: '/',
    meta: { requiresAuth: true },
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'Root',

        redirect: { name: 'Home' }
      },
      {
        name: 'Home',
        path: '/home',
        component: () => import('src/pages/HomePage.vue')
      },

      ...properties,

      ...realEstateDevelopments,

      ...realEstateDevelopmentsAccessories,

      ...realEstateDevelopmentsBatch,

      ...realEstateDevelopmentsBlueprints,

      ...realEstateDevelopmentsCharacteristics,

      ...realEstateDevelopmentsDocuments,

      ...realEstateDevelopmentsLayout,

      ...realEstateDevelopmentsMedias,

      ...realEstateDevelopmentsMirrors,

      ...realEstateDevelopmentsParameters,

      ...realEstateDevelopmentsPersonalizations,

      ...realEstateDevelopmentsSettings,

      ...realEstateDevelopmentsSettingsAccessories,

      ...realEstateDevelopmentsSettingsAccessoriesCategorization,

      ...realEstateDevelopmentsSettingsAttributes,

      ...realEstateDevelopmentsSettingsBuyingOptions,

      ...realEstateDevelopmentsSettingsCharacteristics,

      ...realEstateDevelopmentsSettingsInsuranceCompanies,

      ...realEstateDevelopmentsSettingsInsurances,

      ...realEstateDevelopmentsSettingsProposalModel,

      ...realEstateDevelopmentsSettingsReferencePoints,

      ...realEstateDevelopmentsStages,

      ...realEstateDevelopmentsTypologies,

      ...realEstateDevelopmentsUnits,

      ...realEstateDevelopmentsSettingsBankAgencies,

      ...realEstateDevelopmentsSettingsCreditPolicies,

      ...registryOffices,

      ...installmentIntegrationTables,

      ...reports
    ]
  }
]

export default routes
